import { render, staticRenderFns } from "./Badge.vue?vue&type=template&id=55f00fe9&scoped=true"
import script from "./Badge.vue?vue&type=script&lang=ts"
export * from "./Badge.vue?vue&type=script&lang=ts"
import style0 from "./Badge.vue?vue&type=style&index=0&id=55f00fe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f00fe9",
  null
  
)

export default component.exports